import { callGlobalFunction, readGlobal } from "./utils.js";

export const clientFeature = {
  get session() {
    return readGlobal("currentClient", null);
  },
  showDashboard() {
    return callGlobalFunction("showClientDashboard");
  },
  showRegister() {
    return callGlobalFunction("goToClientRegister");
  },
  refreshOrders() {
    return callGlobalFunction("renderClientOrders");
  }
};
